export default {
  1: {
    text: 'Offen',
    color: 'orange lighten-1',
    outlined: false
  },
  2: {
    text: 'Bewilligt',
    color: 'blue lighten-1',
    textColor: '#272727'
  },
  3: {
    text: 'Realisiert',
    color: 'green lighten-2',
    dark: false
  },
  4: {
    text: 'Sistiert',
    color: 'grey lighten-2'
  }
}
